<template>

	<div class="site-content" :class="{ 'loading-blur': !meetingValid }">

		<div class="page betting">
			<div class="page__header betting__header betting__header_no-image">

				<div class="betting__preheader" v-if="!userLogedIn">
					<div class="page__container">
						<div class="race__date">
							{{ raceDateText }}
						</div><!-- /.race__buttons -->
						<div class="race__buttons">
							<router-link
									:to="{ name: 'TimelineWithDate', params: {date: formatToDate(race.details.time)} }"
									class="btn btn--small btn--primary">
								{{t('timeline.button.fill.program')}}
							</router-link>
						</div><!-- /.race__buttons -->
					</div>
				</div><!-- /.betting__preheader -->

				<div class="page__header__banner"></div>

				<ul class="meeting__list">
					<li class="meeting__list__item" :key="'meeting-key--'+meeting.id" :class="{ 'is-current': race.details.meeting_id == meeting.id }"
						v-for="meeting in currentRaceData">
						<router-link :to="'/race/'+meeting.id+'/'+meeting.races[0].id">
							<b class="meeting__number meeting__number--plain">{{meeting.code }}</b> {{ meeting.track }}
						</router-link>
					</li>
				</ul><!-- /.meeting__list -->

				<ul class="race__list">
					<li class="race__list__item" v-for="oneRace in race.meeting.allRaces" :key="'oneRace-key--'+oneRace.id" :class="raceClasses(oneRace)">
						<router-link :to="'/race/'+race.meeting.id+'/'+oneRace.id">
							<b class="race__number race__number--plain">{{oneRace.code }}</b> {{ formatToTime(oneRace.time) }}
						</router-link>
					</li>
				</ul><!-- /.race__list -->

				<div class="page__container">
					<h1 class="page__title betting__title">
						<transition name="fade" mode="out-in">
							<div v-if="race.details && race.details.name && race.meeting && race.meeting.code">
								<span class="icon mr-2" :class="raceStatusClass" :title="t('page.race.status.icon.'+race.details.status)"></span>
								<b>{{ race.meeting.code+' '+ race.details.code}}</b> {{ race.details.name }}
							</div>
						</transition>

					</h1>
					<transition name="fade" mode="out-in">
						<div class="betting__subtitle" v-if="startIn">
							<span class="icon icon--chrono" aria-hidden="true"></span>
							{{ t('race.page.departs.in') }}
							{{ startIn }}
						</div>
					</transition>

				</div>
			</div>
		</div><!-- /.page__header -->

		<!-- Page-content -->
		<div class="page__content">
			<!--<transition name="fade" mode="out-in">

			</transition>-->
			<betslip-component v-if="stateOrchestrator === 'BETSLIP' " :race="race"></betslip-component>
			<result-component v-if="stateOrchestrator === 'RESULT' " :race="race"></result-component>
			<race-loader-component v-if="stateOrchestrator === 'NONE'"></race-loader-component>
		</div>


	</div>

</template>
<script>
	import Vuex from 'vuex';
	import Betslip from './betslip/Betslip.vue';
	import Result from './Result';
	import RaceLoader from '@/components/race/RaceLoader';
	import moment from 'moment-timezone';
	import _ from 'lodash';

	export default {
		name: 'RacePage',
		components: {
			'betslip-component': Betslip,
			'result-component': Result,
			'race-loader-component': RaceLoader
		},
		beforeRouteEnter(to, from, next) {

			//Add auto refresh of race details in global auto refresh function
			next(vm => {
				vm.$store.commit('addRefresh', 'getRaceRefresh')
			})
		},
		beforeRouteLeave(to, from, next) {
			//Add auto refresh of race details in global auto refresh function

			this.$store.commit('removeRefresh', 'getRaceRefresh');
			next();
		},
		data() {
			return {}
		},
		computed: {
			...Vuex.mapState([
				'lang'
			]),
			...Vuex.mapGetters({
				currentRaceData: 'currentRaceData',
				userLogedIn: 'getUserStatus',
				race: 'currentRace'
				// ...
			}),
			//Important things
			meetingId() {
				return this.$route.params['meeting_id']
			},
			raceId() {
				return this.$route.params['race_id']
			},


			stateOrchestrator() {

				/**
				 * could return states of view
				 * - NONE - no info available
				 * - BETSLIP - race open and betting available
				 * - INPROCESS - no results but betting unavailable
				 * - RESULT - race finished and we have result
				 * */
				//return 'NONE';
				if (this.currentRaceData === null || this.race.details.status === 'NONE') {
					return 'NONE';
				} else if (this.race.details.status === 'OPEN' || this.race.details.status === 'RUNNING') {
					return 'BETSLIP';
				} else {
					return 'RESULT';
				}


				/**
				 * Race status available:
				 *
				 * OPEN
				 * RUNNING
				 * CLOSED
				 * CANCELED
				 * FINISHED
				 * OFFICIAL
				 * *
				 * */
			},
			meetingValid() {
				if (this.race.meeting.races) {
					return this.race.meeting.races.some(el => el.id == this.raceId);
				} else {
					return false;
				}
			},


			//Genral calculations
			raceDateText() {
				if (this.race.details) {
					return moment(this.race.details.time).format('DD MMMM YYYY [-] H[h]mm')
				}
			},
			startIn() {
				if (!this.race.details || this.race.details.status === 'NONE') {
					return null;
				}
				let x = moment(this.race.details.time);
				let y = moment();
				let duration = moment.duration(x.diff(y));

				if (duration > 0 && ( this.race.details.status === 'OPEN' || this.race.details.status === 'CLOSED' )) {

					return duration.locale(this.lang).humanize();

				}

				return null;


			},
			timeLeft(){
				//Calc diff between current time and race start time
				if(this.race.details.status === 'CLOSED' || this.race.details.status === 'CANCELED'){
					return -1;
				}
				return (moment(this.race.details.time)).valueOf() - moment().valueOf();
			},
			isWaiting(){

				//Client want to mark it waiting till it don't change status, so we would not block negative difference
				let time = (this.timeLeft >= 0) && (this.timeLeft<= this.waitingPeriod);


				return time && this.race.status === 'OPEN';
			},
			raceStatusClass(){
				let status = [];
				switch (this.race.details.status) {
					case 'CLOSED':
						status.push('icon--close');
						break;
					case 'FINISHED':
						status.push('icon--flag');
						break;
					case 'OFFICIAL':
						status.push('icon--flag');
						break;
					case 'RUNNING':
						status.push('icon--loop');
						break;
					case 'OPEN':
						if(this.isWaiting){
							status.push('icon--chrono');
						}
						break;
				}

				return status;

			}
		},
		watch: {
			'$route'() {
				// обработка изменений параметров пути...
				this.pageChange();
			},

			currentRaceData(){

				setTimeout(()=>{
					this.centerItVariableWidth($('.meeting__list__item.is-current'),$('.meeting__list'));
					this.centerItVariableWidth($('.race__list__item.is-current'),$('.race__list'));

				},100)
			}
		},
		mounted() {
			this.pageChange();
		},
		methods: {
			pageChange() {
				//Handle changes

				if(typeof this.meetingId === 'undefined'){

					this.$store.commit('setRaceId', this.raceId);
				}else{

					//Old Style
					this.$store.commit('setRaceParams', {
						meetingId: this.meetingId,
						raceId: this.raceId
					});
				}

			},
			reverse(array) {
				return _.reverse(array ? array.slice() : []);
			},
			formatToDate(date) {
				return moment(date).format('YYYY-MM-DD');
			},
			raceClasses(race) {
				return {
					'is-current': race.id == this.raceId,
					'is-ended': race.status !== 'OPEN' && race.status !== 'RUNNING', /*race.status === 'CLOSED' || race.status === 'RUNNING'*/
					'is-running':  race.status === 'RUNNING'
				};
			},
			centerItVariableWidth(target, outer){
				let out = $(outer);
				let tar = $(target);
				let x = out.width();
				let y = tar.outerWidth(true);
				let z = tar.index();
				let q = 0;
				let m = out.find('li');
				//Just need to add up the width of all the elements before our target.
				for(var i = 0; i < z; i++){
					q+= $(m[i]).outerWidth(true);
				}
				out.scrollLeft(Math.max(0, q - (x - y)/2));
			}

		}
	}
</script>
<style lang="scss">

	.site-content {
		min-height: 40vh;
	}
</style>